import { render } from "./children-box.vue?vue&type=template&id=47635899&scoped=true"
import script from "./children-box.vue?vue&type=script&lang=js"
export * from "./children-box.vue?vue&type=script&lang=js"

import "./children-box.vue?vue&type=style&index=0&id=47635899&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47635899"]])

export default __exports__